import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ------------------------------------
// Create React Root
// ------------------------------------
const root = ReactDOM.createRoot(document.getElementById("root"));
const rootEl = document.documentElement;

// 🔥 APPLY THEME BEFORE REACT RENDERS (NO WHITE FLASH)
const storedTheme = localStorage.getItem("theme") || "dark";

rootEl.classList.remove("dark", "amoled");

if (storedTheme === "dark") {
  const isMobile = window.matchMedia("(pointer: coarse)").matches;
  const isHighDPI = window.devicePixelRatio >= 2;
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

  if (isMobile && isHighDPI && prefersDark) {
    rootEl.classList.add("amoled");
  } else {
    rootEl.classList.add("dark");
  }
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ------------------------------------
// Register Service Worker (PWA)
// ------------------------------------
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("🚀 Service Worker registered:", registration);

        // OPTIONAL: Auto-refresh when new SW is installed
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  // New update available
                  console.log("🔥 New content available! Refreshing...");
                  // Auto refresh or show update UI
                  window.location.reload();
                } else {
                  console.log("📦 Content cached for offline use.");
                }
              }
            };
          }
        };
      })
      .catch((error) => {
        console.error("❌ Service Worker registration failed:", error);
      });
  });
}
